const Pluralize = (word, amount) => (amount > 1 || amount === 0 ? `${word}s` : word);
export default Pluralize;
